import {
	EuiTable,
	EuiTableHeader,
	EuiTableHeaderCell,
	EuiTableBody,
	EuiTableRow,
	EuiTableRowCell,
} from '@equipmentshare/ds2'

import { PartsOrderedDetail } from '../../../../../graphql'
import OrderTarget from './components/OrderTarget'

export type OrderedTableProps = {
	orders: PartsOrderedDetail[],
}

export default function OrderedTable( { orders }: OrderedTableProps ) {
	return (
		<EuiTable tableLayout="auto">
			<EuiTableHeader>
				<EuiTableHeaderCell>PO Number</EuiTableHeaderCell>
				<EuiTableHeaderCell>Qty Ordered</EuiTableHeaderCell>
				<EuiTableHeaderCell>Item Is For</EuiTableHeaderCell>
			</EuiTableHeader>
			<EuiTableBody>
				{ orders.map( ( o, i ) => {
					const key = `order-${o.purchaseOrderNumber} ${i}`
					return (
						<EuiTableRow key={key}>
							<EuiTableRowCell>{o.purchaseOrderNumber}</EuiTableRowCell>
							<EuiTableRowCell>{o.quantityOrdered}</EuiTableRowCell>
							<EuiTableRowCell><OrderTarget targetId={o.targetId} targetType={o.targetType} /></EuiTableRowCell>
						</EuiTableRow>
					)
				} )}
			</EuiTableBody>
		</EuiTable>
	)
}
